import * as TYPES from '../types';
import { REDUX_CONSTANT, OFFERS } from '../../constants';
import { EditIcon, DownloadIcon } from '../../constants/icon';

const initialState = {
    offerDetailsRedemptionFilterValue: [
        { name: 'All', type: 'item' },
        { name: 'Yes', type: 'item' },
        { name: 'No', type: 'item' }
    ],
    isLoading: false,
    offerDetails3DotsItems: [
        {
            type: 'item',
            name: OFFERS.updateOffer,
            isDisabled: false,
            additionalIcon: { src: EditIcon, alt: OFFERS.updateOffer }
        },
        {
            type: 'item',
            name: OFFERS.download,
            isDisabled: false,
            additionalIcon: { src: DownloadIcon, alt: OFFERS.download }
        }
    ],
    noOfOfferCodes: 0
};

export default function getOffersInformation(state = initialState, action) {
    switch (action.type) {
        case REDUX_CONSTANT.GET_VENDOR_OFFERS_LIST:
            let offersListData =
                action.payload &&
                action.payload.items &&
                action.payload.items.length !== 0
                    ? action.payload.items
                    : [];
            return {
                ...state,
                offersListData: offersListData,
                pageNumber: action.payload.pageNumber,
                pageSize: action.payload.pageSize,
                recordCount: action.payload.recordCount,
                sortField: action.payload.sortField,
                sortOrder: action.payload.sortOrder,
                searchText: action.payload.searchText
                    ? action.payload.searchText
                    : '',
                isLoading: false,
                currentVendorId: action.payload.vendorId
            };
        case REDUX_CONSTANT.CREATE_NEW_OFFER_DATA:
            return {
                ...state,
                createNewOfferData: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.UPDATE_OFFER_DATA:
            return {
                ...state,
                updateOfferData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_OFFER_DETAILS:
            let offerDetailsData =
                action.payload &&
                action.payload.items &&
                action.payload.items.length !== 0
                    ? action.payload.items
                    : [];
            return {
                ...state,
                offerDetailsResponse: action.payload,
                offerDetailsList: offerDetailsData,
                offerHeaderInfo: action.payload.offerDetailPageDto,
                sortFieldForOfferDetails: action.payload.sortField,
                sortOrderForOfferDetails: action.payload.sortOrder,
                pageNumberForOfferDetails: action.payload.pageNumber,
                pageSizeForOfferDetails: action.payload.pageSize,
                recordCountForOfferDetails: action.payload.recordCount,
                isLoading: false
            };
        case REDUX_CONSTANT.DOWNLOAD_OFFER_DATA:
            return {
                ...state,
                isLoading: false,
                offerDownloadedData: action.payload
            };
        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };
        case REDUX_CONSTANT.SET_NUMBER_OF_OFFER_CODE_CREATED:
            return {
                ...state,
                noOfOfferCodes: action.payload,
                isLoading: false
            };
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                offersListData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_OFFERS_LIST
                        ? []
                        : state.offersListData,
                recordCount:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_OFFERS_LIST
                        ? 0
                        : state.recordCount,

                searchText:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_OFFERS_LIST
                        ? ''
                        : state.searchText,
                offerDetailsResponse:
                    action.payload.title === REDUX_CONSTANT.GET_OFFER_DETAILS
                        ? action.payload.msg
                        : state.offerDetailsResponse,
                updateOfferData:
                    action.payload.title === REDUX_CONSTANT.UPDATE_OFFER_DATA
                        ? action.payload.msg
                        : state.updateOfferData,
                createNewOfferData:
                    action.payload.title ===
                    REDUX_CONSTANT.CREATE_NEW_OFFER_DATA
                        ? action.payload.msg
                        : state.createNewOfferData
            };
        default:
            return state;
    }
}
